t = require('app/scripts/views/internal/teacup-with-helpers')('popover_reopen_board')
localizeCount = require 'app/scripts/lib/localize-count'

module.exports = t.renderable ->
  t.div '.js-billable-guests-alert'
  t.input '.primary.full.js-confirm-reopen', { type: 'submit', value: t.l('confirm') }
